
import {
    GET_ROLES,
    GET_ROLES_SUCCESS,
    GET_ROLES_FAIL,
    GET_ROLE_DETAIL,
    GET_ROLE_DETAIL_SUCCESS,
    GET_ROLE_DETAIL_FAIL,
    ADD_NEW_ROLE,
    ADD_NEW_ROLE_SUCCESS,
    ADD_NEW_ROLE_FAIL,
    UPDATE_ROLE,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_FAIL,
    DELETE_ROLE,
    DELETE_ROLE_SUCCESS,
    DELETE_ROLE_FAIL,
    GET_PERMISSIONS,
    GET_PERMISSIONS_SUCCESS,
    GET_PERMISSIONS_FAIL,
} from "./actionTypes"

export const getRoles = () => ({
    type: GET_ROLES,
})

export const getRolesSuccess = roles => ({
    type: GET_ROLES_SUCCESS,
    payload: roles,
})

export const getRolesFail = error => ({
    type: GET_ROLES_FAIL,
    payload: error,
})

export const getRoleDetail = id => ({
    type: GET_ROLE_DETAIL,
    payload: id,
})

export const getRoleDetailSuccess = role => ({
    type: GET_ROLE_DETAIL_SUCCESS,
    payload: role,
})

export const getRoleDetailFail = error => ({
    type: GET_ROLE_DETAIL_FAIL,
    payload: error,
})

export const addNewRole = role => ({
    type: ADD_NEW_ROLE,
    payload: role,
})

export const addNewRoleSuccess = role => ({
    type: ADD_NEW_ROLE_SUCCESS,
    payload: role,
})

export const addNewRoleFail = error => ({
    type: ADD_NEW_ROLE_FAIL,
    payload: error,
})

export const updateRole = role => ({
    type: UPDATE_ROLE,
    payload: role,
})

export const updateRoleSuccess = role => ({
    type: UPDATE_ROLE_SUCCESS,
    payload: role,
})

export const updateRoleFail = error => ({
    type: UPDATE_ROLE_FAIL,
    payload: error,
})

export const deleteRole = id => ({
    type: DELETE_ROLE,
    payload: id,
})

export const deleteRoleSuccess = id => ({
    type: DELETE_ROLE_SUCCESS,
    payload: id,
})

export const deleteRoleFail = error => ({
    type: DELETE_ROLE_FAIL,
    payload: error,
})

export const getPermissions = () => ({
    type: GET_PERMISSIONS,
})

export const getPermissionsSuccess = permissions => ({
    type: GET_PERMISSIONS_SUCCESS,
    payload: permissions,
})

export const getPermissionsFail = error => ({
    type: GET_PERMISSIONS_FAIL,
    payload: error,
})
